import { Value, AdvancedSearchTypes, FavouriteConditionValue, FavouriteCondition } from 'app/types-shared';
import { ComplexValue } from 'app/infrastructure/ui/form/types';
import { SelectItem } from 'ui/common/select/types';

export interface FilterDomainsResults {
  predefDateDefaultValue?: DbFunctionResult;
  reportTypeDescription?: string;
  usePredefDate?: boolean;
  filterDomain: FilterDomainNode[];
}

export interface DbFunctionResult {
  dbFunction: number;
}

export interface FilterDomainNode {
  domain: number;
  label: string;
  sequence?: number;
  advancedSearchType: number;
  searchRequired?: boolean;
  required?: boolean;
}

export interface Filter extends FilterDomainNode {
  id: string;

  advancedField: AdvancedSearchTypes;

  initialValue: any;
  conditions: FavouriteCondition[];

  optionType: OptionTypes;
  subOptionTypes: SubOptionTypes[];
  menuOptions: FilterOption[];

  isOpen: boolean;
  added?: boolean;
}

export interface IFilter {
  component: any;
  optionsEndpoint: (id?: number) => string;  
  postfix?: string[];
  categoryOptionsEndpoint: (id?: number) => string;
  displayCategories?: boolean;
}

export enum FilterTypes {
  SelectMultiple = 1,
  SelectMultipleHierarchy = 2,
  TextField = 5,
  DateField = 6,
  NumberField = 7,
  CheckBox = 8,
  DecimalNumber = 10,
  MyUnit = 11,
  MyLocation = 12,
  Person = 13,
  SelectMultipleFlat = 14,
  SelectMultipleFlatWithCategories = 15,
  SelectMultipleHierarchyWithCategories = 16,
  SelectMultipleFlatSequentialWithCategories = 17,
  SelectMultipleHierarchySequentialWithCategories = 18,
  PredefDate = 5001,
  PredefFilters = 5002
}

export interface FiltersState {
  instances: Record<string, FiltersInstanceState>;
}

export interface AdvancedSearchField {
  domain: number;
  domainNode?: number;
  codetableId?: number;
  label: string;
  advancedSearchType: number;
  children?: AdvancedSearchField[];
  searchRequired?: boolean;
}

export interface OriginalDomainNodeOption extends AdvancedSearchField {
  d?: string;
  pad?: string;
}

export interface FiltersInstanceState {
  //current list of showed filters inside FilterPanel.
  currentList: Filter[];
  //available advancedSearchFields which will be input for "add new filter" options.
  advancedSearchFields: AdvancedSearchField[];
  originalDomainNodeOptions?: OriginalDomainNodeOption[];
  replaceDomainNodeOptions?: AdvancedSearchField[];
  removeDomainNodeOptions?: AdvancedSearchField[];
  //advancedSearchTypes which will be needed to create favourite conditions.
  advancedSearchTypes: AdvancedSearchTypes[];
  // predefined list of filters
  filterDomains: FilterDomainNode[];
  reportData?: ReportData;
}

export interface ReportData {

  reportTypeDescription?: string;

  usePredefDate: boolean;
}

export interface AdvancedSearchFieldResults {
  messages: any;
  data: AdvancedSearchField[];
}

export enum FilterDomains {
  PredefFilters = 102,
  PredefDate = 103
}

export enum ConnectionsOperatorTypes {
  include = 0,
  exclude = 20
}

export const ExactLevelTypes = {
  include: false,
  exclude: true
};

export enum ConditionValuesOperator {
  equal = 14,
  less = 10,
  largerOrEqual = 11,
  lessOrEqual = 12,
  between = 7,
  empty = 5,
  or = 2
}

export enum ConditionValuesDbFunction {
  upper = 6
}

export type ConditionValue = number | string | SelectItem[];

export interface ConditionTypesValueData {
  operator: Value;
  dbFunction: Value;
}

export interface ConditionTypesValue {
  [filterType: number]: {
    [valueType: number]: ConditionTypesValueData;
  };
}

export enum ConditionValueTypes {
  default,
  fixedPeriod,
  dateRangeFrom,
  dateRangeTo,
  userProfile,
  numberSingle,
  numberSingleLargerOrEqual,
  numberSingleLess,
  numberRange,
  notSpecified,
  matchExact,
  decimalFrom,
  decimalTo
}

export interface UserProfile {
  id: number;
  name: string;
  unit: ComplexValue<number>;
  location: ComplexValue<number>;
}

export interface FilterValues {
  [index: number]: {
    value: FavouriteConditionValue | FavouriteConditionValue[];
    selector?: boolean;
  };
}

export enum FilterMenuOptionsTypes {
  MainLevel,
  SubLevel
}

export enum FilterMenuOptions {
  Clear,
  Include,
  Exclude,
  IncludeSubLevels,
  ExcludeSubLevels
}

export interface FilterOption {
  id: string;
  option?: FilterMenuOptions;
  type?: FilterMenuOptionsTypes | OptionTypes;
  subOptionTypes?: SubOptionTypes[];
}

export enum OptionTypes {
  FixedPeriod,
  SpecificPeriodRange,
  NotSpecified,
  ContainsWords,
  SpecificNumbersOrRanges
}

export enum SubOptionTypes {
  MatchExact
}
